import styled from 'styled-components';

import colors from '../../../../../../../styles/colors';
import {
  Container,
  Title,
  StyledIconButton,
} from '../EventContent/styles';

// A dashed outline marks the workout as a draft: scheduled, not assigned yet.
const DraftContainer = styled(Container)`
  background-color: ${colors.base.alpha};
  border: 1px dashed ${colors.shades.secondary8};
  color: ${colors.shades.secondary8};
  gap: 4px;
`;

const DraftTitle = styled(Title)`
  font-size: 12px;
`;

const DraftIconButton = styled(StyledIconButton)`
  color: ${colors.shades.secondary8};
`;

const ScheduleIconWrapper = styled.div`
  display: flex;
  align-items: center;

  svg {
    width: 14px;
    height: 14px;
  }
`;

export {
  DraftContainer,
  DraftTitle,
  DraftIconButton,
  ScheduleIconWrapper,
};
